export function disableVideoDownload() {
    document.addEventListener('contextmenu', function (e) {
        if (e.target instanceof HTMLVideoElement) {
            e.preventDefault();
        }
    });
}
